(() => {
  /* ================================================================
     Fresh Experience Set — cart-drawer upsell (Discovery Set owners)
     Klon AddTheTravelSize.js. Trigger: koszyk zawiera Discovery Set.
     Oferta: Fresh Experience Set z £10 credit (realny rabat = Shopify
     Automatic Discount w Adminie; JS pokazuje ofertę i dodaje produkt).
     ================================================================ */

  /* ---- KONFIG ---- */
  const FE_HANDLE   = 'fresh-experience';        // produkt upsellowany
  // URL packshotu z wypalonym badge wstrzykuje layout przez {{ 'fresh-set-badge-packshot.png' | asset_url }},
  // bo sciezka CDN jest inna w kazdym sklepie. Brak zmiennej = fallback na zdjecie produktu.
  const BADGED_PACKSHOT = (typeof window !== 'undefined' && window.ITB_FE_PACKSHOT) || '';
  const CREDIT_PENCE = 1000;                     // £10 credit
  const MARKER      = 'freshset';                // _amp_gift marker (własny)
  const DISCOVERY_MATCH = 'discover';       // trigger: handle line itemu zawiera to
  const EXP_KEY     = 'fresh-experience-upsell-2026-07'; // GrowthBook experiment trackingKey (50/50)
  // Rabat idzie KODEM, nie automatem: dostaje go wylacznie ten, kto kliknal ADD +,
  // wiec grupa kontrolna widzi normalna cene i test mierzy oferte, a nie sama karte.
  const DISCOUNT_CODE = 'FRESHSET10';            // BXGY: Discovery Set -> Fresh Experience -10 GBP

  /* ---- A/B gating (GrowthBook) ----
     Pokazuj kartę tylko dla treatment (wariant 1). Kolejność:
     1) forced cookie itb_ab_{EXP_KEY}=0|1 (CF Worker / test),
     2) GB assignment z window.ITB_GB.exposures,
     3) default = control (0) → ukryte (draft/nieprzypisane). */
  function getVariant(){
    try {
      // override do recenzji/testu: ?fe_upsell=1|0 (zapisuje cookie, żeby przetrwać strip preview)
      const u = new URLSearchParams(location.search).get('fe_upsell');
      if (u === '1' || u === '0') { document.cookie = 'itb_ab_' + EXP_KEY + '=' + u + ';path=/;max-age=86400'; return parseInt(u, 10); }
      const m = document.cookie.match(new RegExp('(?:^|; )itb_ab_' + EXP_KEY + '=([0-9]+)'));
      if (m) return parseInt(m[1], 10);
      const ex = ((window.ITB_GB && window.ITB_GB.exposures) || []).find(e => e && e.key === EXP_KEY);
      if (ex) return parseInt(ex.variationKey != null ? ex.variationKey : ex.variationId, 10);
    } catch(_){}
    // PROD: DEFAULT = NIE pokazuj. To ma byc TEST, nie zmiana dla wszystkich —
    // wariant przydziela wylacznie cookie itb_ab_* (CF Worker) albo exposure z GrowthBooka.
    // Podglad bez losowania: ?fe_upsell=1.
    return 0;
  }

  /* ---- CSS (kafelek) ---- */
  const STYLE = `
#itb-fresh-set-card{position:relative;display:block;padding:0 16px;border-top:1px solid #eee}
#itb-fresh-set-card .itb-head{text-align:center;font-size:1.15rem;font-weight:700;color:#253D41;padding:14px 0;border-bottom:1px solid #eee}
#itb-fresh-set-card .itb-row{display:flex;gap:16px;align-items:stretch;padding:12px 0}
#itb-fresh-set-card .itb-close{position:absolute;top:10px;right:10px;z-index:2;width:22px;height:22px;line-height:20px;text-align:center;border:none;background:transparent;color:#9a9a9a;font-size:18px;cursor:pointer;padding:0}
#itb-fresh-set-card .itb-close:hover{color:#000}
#itb-fresh-set-card.item{margin:0}
#itb-fresh-set-card .itb-media{flex:0 0 auto;display:flex;align-items:center}
#itb-fresh-set-card .itb-thumb{position:relative;display:block;line-height:0}
#itb-fresh-set-card .itb-media img{width:100px;height:100px;object-fit:contain}
#itb-fresh-set-card .itb-body{display:flex;flex-direction:column;flex:1 1 auto;min-width:0;gap:6px}
#itb-fresh-set-card .itb-eyebrow{margin:0;font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#00485A;font-weight:700}
#itb-fresh-set-card .itb-title{font-weight:600;margin:0;width:100%;line-height:1.1}
#itb-fresh-set-card .itb-sub{opacity:.6;margin:0;font-size:14px;color:rgba(0,0,0,.6);line-height:1.2}
#itb-fresh-set-card .itb-tagline{margin:0;font-size:14px;color:#777544;line-height:1.2}
#itb-fresh-set-card .itb-badge{display:inline-block;font-size:11px;font-weight:700;color:#00485A;background:#EAF3F5;border-radius:2px;padding:2px 6px;line-height:1}
#itb-fresh-set-card .itb-action-row{display:flex;align-items:center;justify-content:space-between;margin-top:auto;gap:.5rem}
#itb-fresh-set-card .itb-price-row{display:flex;gap:.4rem;align-items:baseline}
#itb-fresh-set-card .itb-price-now{font-weight:700;font-size:1rem;color:#000}
#itb-fresh-set-card .itb-price-was{font-size:.85rem;color:#9a9a9a;text-decoration:line-through;font-weight:400}
#itb-fresh-set-card .itb-add-btn{
  background:#fff;border:1px solid #B0B0B0;color:#000;
  font-size:.9rem;font-weight:700;text-transform:uppercase;
  padding:.4rem .85rem;border-radius:0;cursor:pointer;letter-spacing:.02em
}
#itb-fresh-set-card .itb-add-btn:hover{background:#f5f5f5}
#itb-fresh-set-card .itb-add-btn[disabled]{opacity:.6;cursor:not-allowed}
`;

  function addStyle() {
    if (document.getElementById('itb-fresh-set-style')) return;
    const s = document.createElement('style');
    s.id = 'itb-fresh-set-style';
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  // Kotwica = lista pozycji koszyka. Kartę wstrzykujemy PO niej (stabilny region drawera,
  // NIE w free-gifts który SlideCart re-renderuje → to powodowało pętlę cart.js).
  function anchorItems(){ return document.querySelector('#slidecarthq .items'); }
  function container(){ const it = anchorItems(); return it ? it.parentElement : null; }

  /* ---- Cart state ---- */
  let CART_CACHE = null, CART_FETCH_PROMISE = null;
  async function getCart(force = false){
    if (!force && CART_CACHE) return CART_CACHE;
    if (CART_FETCH_PROMISE) return CART_FETCH_PROMISE;
    CART_FETCH_PROMISE = fetch('/cart.js', { cache:'no-store', credentials:'same-origin' })
      .then(r => r.ok ? r.json() : { items:[] })
      .then(c => { CART_CACHE = c; return c; })
      .catch(() => ({ items:[] }))
      .finally(() => { CART_FETCH_PROMISE = null; });
    return CART_FETCH_PROMISE;
  }
  function invalidateCart(){ CART_CACHE = null; }

  // Single-gift: ukryj jeśli JAKIKOLWIEK _amp_gift jest w koszyku (travel40/bfc50/freshset)
  function cartHasAnyGift(cart){
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(it => it && it.properties && it.properties._amp_gift);
  }
  function cartHasDiscoverySet(cart){
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(it => {
      const h = (it.handle || '').toLowerCase();
      const t = (it.product_title || it.title || '').toLowerCase();
      return h.includes(DISCOVERY_MATCH) || t.includes('discovery set');
    });
  }
  function cartHasFreshSet(cart){
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(it => (it.handle || '').toLowerCase() === FE_HANDLE);
  }

  function formatMoney(pence){ return '£' + (pence / 100).toFixed(2); }

  /* ---- SlideCart refresh ---- */
  async function refreshSlideCart(){
    await new Promise((resolve) => {
      if (typeof window.SLIDECART_UPDATE === 'function') {
        let done = false;
        try { window.SLIDECART_UPDATE(() => { done = true; resolve(); }); }
        catch(_){ resolve(); return; }
        setTimeout(() => { if (!done) resolve(); }, 800);
      } else { resolve(); }
    });
    ['cart:updated','itb:cart:refresh'].forEach(ev => {
      try { document.dispatchEvent(new CustomEvent(ev, { bubbles:true, cancelable:true })); } catch(_){}
    });
  }

  /* ---- FE product data (dynamiczne: was=cena, now=cena-credit) ---- */
  let FE_CACHE = null;
  async function getFreshData(){
    if (FE_CACHE) return FE_CACHE;
    try {
      const r = await fetch('/products/' + FE_HANDLE + '.js', { cache:'no-store', credentials:'same-origin' });
      if (!r.ok) return null;
      const p = await r.json();
      const v = (p.variants || []).find(x => x.available) || (p.variants || [])[0];
      if (!v) return null;
      const wasP = v.price;
      const nowP = Math.max(0, wasP - CREDIT_PENCE);
      FE_CACHE = {
        title: p.title,
        variantId: v.id,
        // Czysty packshot pudełka = 2. zdjęcie (images[1]), nie featured (index 0 = muszelki/kompozycja).
        // Spec: „clean packshot… not the shells and starfish composition".
        // Packshot z WYPALONYM badge „£10 off” (jak AddTheTravelSize.js/100ffm.jpg) — badge w obrazku,
        // nie w CSS: nie odkleja się od zdjęcia i nie rozjezdża się przy innych szerokościach/fontach.
        image: BADGED_PACKSHOT || ((p.images && p.images[1]) || p.featured_image || (p.images && p.images[0]) || ''),
        priceNow: formatMoney(nowP),
        priceWas: formatMoney(wasP)
      };
      return FE_CACHE;
    } catch(_){ return null; }
  }

  /* ---- Karta ---- */
  let CURRENT_DATA = null;
  let injecting = false; // guard: nasze własne zmiany DOM nie mają re-triggerować observera (pętla)

  async function ensureCard() {
    if (injecting) return;
    const host = container();
    if (!host) return;
    const cart = await getCart();

    const remove = () => { injecting = true; const e = document.getElementById('itb-fresh-set-card'); if (e) e.remove(); CURRENT_DATA = null; setTimeout(() => { injecting = false; }, 0); };

    // Guard 0 — user odrzucił kartę (x) w tej sesji → nie pokazuj (spec: hide once declined in that session)
    try { if (sessionStorage.getItem('itb_fe_dismissed_' + EXP_KEY) === '1') return remove(); } catch(_){}
    // Guard 1 — jakikolwiek gift już dodany (single-gift, w tym nasz freshset) → ukryj
    if (cartHasAnyGift(cart)) return remove();
    // Guard 2 — FE Set już w koszyku (dodany normalnie) → ukryj
    if (cartHasFreshSet(cart)) return remove();
    // Guard 3 — trigger: brak Discovery Set w koszyku → ukryj
    if (!cartHasDiscoverySet(cart)) return remove();
    // Guard 4 — A/B: pokazuj tylko treatment (wariant 1); control/draft → ukryj
    if (getVariant() !== 1) return remove();

    const data = await getFreshData();
    if (!data || !data.variantId) return remove();
    CURRENT_DATA = data;

    injecting = true; // od tego miejsca modyfikujemy DOM
    let el = document.getElementById('itb-fresh-set-card');
    if (!el) {
      el = document.createElement('div');
      el.id = 'itb-fresh-set-card';
      el.classList.add('item');
      el.innerHTML = `
        <button type="button" class="itb-close" aria-label="Dismiss">&times;</button>
        <div class="itb-head">Yours for the season</div>
        <div class="itb-row">
        <div class="itb-media">
          <span class="itb-thumb">
            <img src="${data.image}" alt="Fresh Set"/>
          </span>
        </div>
        <div class="itb-body">
          <div class="itb-title">Add the Fresh Set, £10 off</div>
          <div class="itb-sub">Size: 10 scents, 2ml each</div>
          <div class="itb-tagline">10 new scents for summer, just £19 more</div>
          <div class="itb-action-row">
            <button type="button" class="itb-add-btn">ADD +</button>
            <div class="itb-price-row">
              <span class="itb-price-now">${data.priceNow || ''}</span>
              <span class="itb-price-was">${data.priceWas || ''}</span>
            </div>
          </div>
        </div>
        </div>`;
      el.querySelector('.itb-add-btn').addEventListener('click', onAddClick);
      el.querySelector('.itb-close').addEventListener('click', onDismiss);
    } else {
      const now = el.querySelector('.itb-price-now');
      const was = el.querySelector('.itb-price-was');
      // pisz TYLKO gdy zmiana (inaczej niepotrzebna mutacja → re-trigger)
      if (now && now.textContent !== (data.priceNow || '')) now.textContent = data.priceNow || '';
      if (was && was.textContent !== (data.priceWas || '')) was.textContent = data.priceWas || '';
    }
    // Wstaw TYLKO gdy karty nie ma w drawerze (NIE przesuwaj jeśli już wisi → to była pętla).
    const items = anchorItems();
    if (items && !el.closest('#slidecarthq')) items.insertAdjacentElement('afterend', el);
    setTimeout(() => { injecting = false; }, 0); // zwolnij guard po ustabilizowaniu DOM
  }

  // Odrzucenie (x): zapamiętaj na sesję i ukryj (spec: hide once declined in that session)
  function onDismiss(){
    try { sessionStorage.setItem('itb_fe_dismissed_' + EXP_KEY, '1'); } catch(_){}
    injecting = true;
    const e = document.getElementById('itb-fresh-set-card'); if (e) e.remove();
    CURRENT_DATA = null;
    setTimeout(() => { injecting = false; }, 0);
  }

  async function applyDiscountCode(){
    try {
      // redirect=/cart.js zamiast pelnej strony — ustawia cookie rabatu, zwraca lekki JSON
      await fetch('/discount/' + DISCOUNT_CODE + '?redirect=/cart.js', {
        cache: 'no-store', credentials: 'same-origin'
      });
    } catch (err) {
      // Nie przerywamy: produkt jest juz w koszyku, rabat sprobujemy nalozyc ponownie
      // przy kolejnym dodaniu. Lepiej brak rabatu niz zerwany add-to-cart.
      console.warn('[FreshExperienceSet] discount code failed', err);
    }
  }

  async function onAddClick(e){
    e.preventDefault();
    const btn = e.currentTarget;
    const data = CURRENT_DATA;
    if (!data || !data.variantId) return;
    btn.setAttribute('disabled', 'true');
    btn.textContent = 'ADDING…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(data.variantId), quantity: 1, properties: { _amp_gift: MARKER } }] }),
        cache: 'no-store', credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('add.js failed');
      // PRZED odswiezeniem drawera, zeby koszyk od razu pokazal 19 zamiast 29.
      await applyDiscountCode();
      invalidateCart();
      await refreshSlideCart();
      await ensureCard(); // FE już w koszyku → ensureCard usunie kartę (single-gift guard)
    } catch (err) {
      console.error('[FreshExperienceSet] add failed', err);
    } finally {
      btn.removeAttribute('disabled');
      btn.textContent = 'ADD +';
    }
  }

  /* ---- Boot: INJECT-ON-OPEN ----
     Kluczowe: NIE używamy ciągłego MutationObservera na treści drawera (to walczyło z
     re-renderem SlideCart → pętla cart.js). Zamiast tego wstrzykujemy kartę RAZ przy
     OTWARCIU koszyka (event/klasa .open). Statyczny node przeżywa re-render SlideCart. */

  function waitForElm(sel) {
    return new Promise(resolve => {
      const e = document.querySelector(sel);
      if (e) return resolve(e);
      const mo = new MutationObserver(() => { const n = document.querySelector(sel); if (n) { mo.disconnect(); resolve(n); } });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    });
  }

  // Po otwarciu: 1× świeży koszyk, poczekaj aż SlideCart wyrenderuje .items, wstrzyknij raz.
  async function onOpen(){
    addStyle();
    invalidateCart();
    for (let i = 0; i < 8; i++) {
      if (anchorItems()) { await ensureCard(); return; }
      await new Promise(r => setTimeout(r, 200));
    }
  }

  // Wykrycie otwarcia = zmiana klasy .open na overlayu (attribute-only observer → NIE reaguje
  // na re-render treści → brak pętli). onOpen wywoływane raz na przejście closed→open.
  let wasOpen = false;
  function overlayOpen(){ const o = document.querySelector('.slidecarthq-overlay'); return !!(o && o.classList.contains('open')); }
  function checkOpen(){ const now = overlayOpen(); if (now && !wasOpen) { wasOpen = true; onOpen(); } else if (!now) { wasOpen = false; } }

  waitForElm('.slidecarthq-overlay').then(o => {
    const mo = new MutationObserver(checkOpen);
    mo.observe(o, { attributes: true, attributeFilter: ['class'] });
    checkOpen(); // gdyby już był otwarty
  });

  // Zapas: podpięcie pod globalny SLIDECART_OPEN (jeśli istnieje / gdy się pojawi)
  (function hookOpen(){
    let hooked = false;
    const tryHook = () => {
      if (hooked || typeof window.SLIDECART_OPEN !== 'function') return;
      const orig = window.SLIDECART_OPEN;
      window.SLIDECART_OPEN = function(){ const r = orig.apply(this, arguments); wasOpen = true; setTimeout(onOpen, 300); return r; };
      hooked = true;
    };
    tryHook();
    if (!hooked) { let t = setInterval(() => { tryHook(); if (hooked) clearInterval(t); }, 500); setTimeout(() => clearInterval(t), 8000); }
  })();
})();

